document.addEventListener("DOMContentLoaded", () => {

  const wrapper = document.querySelector(".bundle-wrapper");
  if (!wrapper) return;

  const options = wrapper.querySelectorAll(".bundle-option");
  const button = wrapper.querySelector(".bundle-add-btn");

  // ✅ Get main product variant safely
  const mainVariantId = wrapper.dataset.mainVariant;

  // Toggle selection
  options.forEach(opt => {
    opt.addEventListener("click", () => {
      options.forEach(o => o.classList.remove("active"));
      opt.classList.add("active");
      opt.querySelector("input").checked = true;
    });
  });

  // Add to cart
  button.addEventListener("click", () => {

    const active = wrapper.querySelector(".bundle-option.active");
    const type = active.dataset.type;

    let items = [];

    // Always add main product
    items.push({
      id: parseInt(mainVariantId),
      quantity: 1
    });

    // If bundle selected → add extra products
    if (type === "bundle") {
      wrapper.querySelectorAll("[data-bundle-variant]").forEach(el => {
        items.push({
          id: parseInt(el.dataset.bundleVariant),
          quantity: 1
        });
      });
    }

    // AJAX add
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(res => res.json())
    .then(() => {
      window.location.href = "/cart";
    })
    .catch(err => {
      console.error("Cart Error:", err);
    });

  });

});